import { useEffect, useState } from "react";
import axios from "axios";

export default function PaymentSuccess() {
  const [orderData, setOrderData] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem("cakeOrderInfo");
    if (!stored) return;

    const parsed = JSON.parse(stored);
    setOrderData(parsed);

    const submitOrder = async () => {
      try {
        await axios.post(
          "https://kld931ajj1.execute-api.us-east-1.amazonaws.com/v1/custom-grad-cake",
          parsed,
          { headers: { "Content-Type": "application/json" } }
        );
        localStorage.removeItem("cakeOrderInfo");
      } catch (err) {
        console.error("Error submitting cake order:", err);
      }
    };

    submitOrder();
  }, []);

  const formatPrice = (price) =>
    Number(price) % 1 === 0 ? `$${Number(price)}` : `$${Number(price).toFixed(2)}`;

  if (!orderData) {
    return (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <h2>Loading your cake summary...</h2>
      </div>
    );
  }

  const { numTiers, toppers, edibleAddOns, customName, dietaryRestrictions, tierFlavors, servings,  numberofTiersPrice,
    toppersPrice,
    edibleAddonsPrice,
    customMessagePrice,
    dietaryRestrictionsPrice,
    totalPrice, cakeImageFilename,
    cakeImageBase64, } = orderData;

  return (

    
    <div style={{ padding: "2rem", textAlign: "center", maxWidth: "800px", margin: "0 auto" }}>
     
     <div
      style={{
        backgroundColor: "#FFE4EC",
        border: "1px solid #F48FB1",
        color: "#C2185B",
        padding: "1rem",
        borderRadius: "12px",
        fontWeight: "600",
        marginBottom: "2rem",
        fontSize: "1.1rem",
      }}
    >
      📧 You'll receive a confirmation email from <strong>cakery.app.dev@gmail.com</strong> — please check your spam folder!
    </div>
     
      <img
        src="/capAndGown.png"
        alt="Cupcake"
        style={{ maxWidth: "300px", marginBottom: "1rem" }}
      />
      <h2>Thank you for your payment!</h2>
      <p>Your cake order has been received. We’ll be in touch soon!</p>

      <img src={orderData.cakeImageBase64} alt="Cake Preview" style={{ width: "100%", maxWidth: "300px" }} />


      <hr style={{ margin: "2rem 0" }} />

      <h4 className="mb-3">Order Summary</h4>
      <table className="table table-bordered" style={{ fontSize: "0.95rem" }}>
        <tbody>
          <tr>
            <th>Number of Tiers</th>
            <td>{numTiers}</td>
            <td>{formatPrice(numberofTiersPrice)}</td>
          </tr>
          <tr>
            <th>Toppers</th>
            <td>{toppers.length > 0 ? toppers.join(", ") : "None"}</td>
            <td>{formatPrice(toppersPrice)}</td>
          </tr>
          <tr>
            <th>Edible Add-Ons</th>
            <td>{edibleAddOns.length > 0 ? edibleAddOns.join(", ") : "None"}</td>
            <td>{formatPrice(edibleAddonsPrice)}</td>
          </tr>
          {edibleAddOns.includes("congratulations") && (
            <tr>
              <th>Custom Message</th>
              <td>Congratulations {customName}</td>
              <td>{formatPrice(20)}</td>
            </tr>
          )}
          <tr>
            <th>Dietary Restrictions</th>
            <td>{dietaryRestrictions.length > 0 ? dietaryRestrictions.join(", ") : "None"}</td>
            <td>{formatPrice(dietaryRestrictionsPrice)}</td>
          </tr>
          <tr>
            <th>Flavors</th>
            <td colSpan="2">
              {tierFlavors.map((tier, idx) => (
                <div key={idx}>
                  {numTiers === "2" && <strong>Tier {idx + 1}: </strong>}
                  {tier.cake || tier.icing ? `${tier.cake} cake with ${tier.icing} icing` : "Not selected"}
                </div>
              ))}
            </td>
          </tr>
         
          <tr>
            <th>Name</th>
            <td colSpan="2">{orderData.guestName}</td>
          </tr>
          <tr>
            <th>Email</th>
            <td colSpan="2">{orderData.guestEmail}</td>
          </tr>
          <tr>
            <th>Phone #</th>
            <td colSpan="2">{orderData.guestPhone}</td>
          </tr>
          <tr>
            <th>Preferred Contact</th>
            <td colSpan="2">{orderData.preferredContactMethod}</td>
          </tr>

           <tr>
           <th>Delivery Method</th>
                <td>{orderData.deliveryMethod === "delivery" ? "Delivery" : "Pickup"}</td>
                <td>{formatPrice(orderData.deliveryFee)}</td>
           </tr>
          {orderData.deliveryMethod === "delivery" && (
            <tr>
              <th>Delivery Address</th>
              <td colSpan="2">{orderData.address || "Not provided"}</td>
            </tr>
          )}
          <tr>
            <th>Date Needed</th>
            <td colSpan="2">{orderData.dateNeeded}</td>
          </tr>
          {orderData.designNotes && (
            <tr>
              <th>Other Feedback</th>
              <td colSpan="2">{orderData.designNotes}</td>
            </tr>
          )}
          <tr>
            <th colSpan="2"><strong>Total</strong></th>
            <th>{formatPrice(totalPrice)}</th>
          </tr>

        </tbody>
      </table>
    </div>
  );
}
